import { GuiBase } from "../GuiBase";

export class GuiLogin2FA extends GuiBase {

    constructor() {
        super("Login2FA");
    }

}
